export class Controller {

    /** @ngInject */
    constructor(ApplicationsResource) {
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
    }

    regenerate() {
        this.isSaving = true;
        this.ApplicationsResource
            .regeneratePassword(this.resolve.companyId, this.resolve.appId)
            .then((data) => this.close({$value: data.applicationPassword}))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/app-key-password/regenerate/regenerate-app-password.controller.js